export class Keycode {
    public keycode: String;
    public deviceid: String;
    public userid: String;
    public authtoken: String;
}
